import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PredictorPage from './pages/PredictorPage';
import IntroLoader from './components/site/IntroLoader';
import CookieBanner from './components/site/CookieBanner';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <IntroLoader />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/predictor" element={<PredictorPage />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
